import { skipToken, useQuery } from "@tanstack/react-query";
import { getAdminCampaignsId } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import { adminCampaignsKeys } from "Api/Queries/Admin/useAdminCampaignsQuery";

export const useCampaignByIdQuery = (id: number | null | undefined) =>
  useQuery<AdminCampaignDto>({
    queryKey: adminCampaignsKeys.detail(id),
    queryFn:
      id != null
        ? processResponseWithApiProblemDetails(() => getAdminCampaignsId(id))
        : skipToken,
    refetchOnWindowFocus: false,
  });
